export const possibleOrientations = { s: 'Straight', g: 'Gay', b: 'Bi-Sexual', t: 'Trans' };

export const orientsSortingArray = Object.keys(possibleOrientations);